export default function CTASection() {
  return (
    <section className="relative w-full h-[85vh] min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20boutique%20interior%20with%20organized%20clothing%20racks%20displaying%20coordinated%20outfits%20in%20neutral%20tones%2C%20wooden%20display%20tables%20with%20folded%20knitwear%20and%20leather%20goods%2C%20soft%20ambient%20pendant%20lighting%20creating%20gentle%20pools%20of%20illumination%2C%20calm%20serene%20retail%20atmosphere%20with%20sage%20green%20walls%20and%20warm%20oak%20flooring%2C%20high%20end%20concept%20store%20photography%20with%20shallow%20depth%20of%20field%20and%20peaceful%20curated%20aesthetic&width=1800&height=1200&seq=cta-bg-v2&orientation=landscape"
          alt="Organized fashion boutique with neatly arranged products"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/10"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end">
            <div className="pt-16 lg:pt-0">
              <h2 className="text-5xl md:text-7xl font-display font-bold text-background-50 leading-[1.1] lowercase">
                ready to shop smarter?
              </h2>
              <div className="mt-12">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-3 bg-background-50 text-foreground-900 h-[56px] px-8 rounded-full text-base font-semibold hover:bg-background-100 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap cursor-pointer group"
                >
                  buy it now
                  <span className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-background-50 text-sm group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </a>
              </div>
            </div>

            <div className="pb-8 lg:pb-16 lg:text-right">
              <p className="text-lg md:text-xl text-background-200/90 font-light leading-relaxed max-w-md lg:ml-auto">
                Thousands of organized product listings.<br />
                One powerful spreadsheet. Better decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}